<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm4 m2 l2>
            <v-layout row elevation-4 class="singin-box">
                <v-flex xs12>
                    <v-card dark tile flat class="signin-right">
                        <v-card-text>
                        <v-container grid-list-sm>
                            <v-layout column>
                                <v-card dark tile flat class="signin-top">
                                    <v-card-text class="text-lg-center">
                                    <div class="display-1 font-weight-light">Login</div>
                                    <div class="display-0 font-weight-light">Please contact Draftworx Support for your login credentials</div>
                                    </v-card-text>
                                </v-card>
                                <v-flex class="subheading text-uppercase">Firm Code</v-flex>
                                <v-flex class="mb-2">
                                    <v-text-field ref="firmGUID" label="Firm Code" v-model="form.FirmGUID" single-line clearable required class="pt-0 dx-uppercase" :rules="[rules.required]" counter maxlength="10"></v-text-field>
                                </v-flex>
                                <v-flex class="subheading text-uppercase">Email</v-flex>
                                <v-flex class="mb-2">
                                    <v-text-field ref="email" label="Email Address" v-model="form.Email" single-line clearable required class="pt-0" :rules="[rules.required]" counter maxlength="100"></v-text-field>
                                </v-flex>
                                <v-flex class="subheading text-uppercase">Password</v-flex>
                                <v-flex class="mb-2">
                                    <v-text-field ref="password" label="Password" v-model="form.Password" single-line clearable required class="pt-0" maxlength="50" :append-icon="passShow ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                                        :rules="[rules.required, rules.min]" :type="passShow ? 'text' : 'password'" @keyup.native="onKey" @click:append="passShow = !passShow"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-alert v-show="loginError" :value="true" type="error">Login attempt failed. Please revise your credentials and try again.</v-alert>
                                </v-flex>
                                <v-flex>
                                    <v-alert v-show="notActive" :value="true" type="error">Your account is not currently active. Please contact support for assistance.</v-alert>
                                </v-flex>
                                <v-flex lg12>
                                    <v-btn color="primary" class="ml-0" :loading="isBusy" @click="signInStart" block>Login</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
const qs = require("qs");

export default {
    name: "Login",
    data() {
        return {
            title: "Sign In",
            isBusy: false,
            passShow: false,
            loginError: false,
            notActive: false,
            form: {
                grant_type: "password",
                FirmGUID: "",
                Email: "",
                Password: "",
            },
            showHide: false,
            rules: {
                required: value => !!value || "This field is required",
                min: v => `${v}`.length >= 8 || "At least 8 characters",
            },
        };
    },
    mounted() {
        this.form.FirmGUID = this.$ls.get("FirmGUID");
        this.form.Email = this.$ls.get("Email");
    },
    methods: {
        onKey(evt) {
            if (evt.key === "Enter") this.onSignIn();
        },
        signInStart() {
            /* if (this.$v.$invalid) {
                this.$alert({ type: "error", title: "Validation", message: "Invalid Results" });
            }
            else {
                this.isBusy = true;
                setTimeout(() => { */
            this.onSignIn();
            // }, 250);
            // }
        },
        onSignIn() {
            this.isBusy = true;
            const config = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            };

            delete this.$http.defaults.headers.common.Authorization;
            this.$http
                .post("/Token", qs.stringify(this.form), config)
                .then((response) => {
                    this.isBusy = false;
                    this.$ls.set("FirmGUID", response.data.firmGUID);
                    this.$ls.set("Email", response.data.email);
                    this.$global.login.loggedIn = true;
                    this.$global.login.firmGUID = response.data.firmGUID;
                    this.$global.login.email = response.data.email;
                    this.$global.login.user = response.data.userName;
                    this.$global.login.administrator = response.data.administrator === "1";
                    this.$global.login.userTypeGUID = response.data.userTypeGUID;
                    this.$global.login.dealerGUID = response.data.dealerGUID;
                    this.$http.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`;
                    this.$global.login.userDescription = `${this.$global.login.dealerGUID} ${this.$global.login.administrator ? "Admin" : ""}`;

                    this.$ga.event({
                        eventCategory: "login",
                        eventAction: "login.success",
                        eventLabel: response.data.email,
                    });

                    this.$router.push({ name: "licenses" });
                })
                .catch((err) => {
                    this.isBusy = false;
                    let msg = "Unknown Error Occured";

                    if (err != null && err.response != null && err.response.data != null && err.response.data.error_description != null) {
                        msg = err.response.data.error_description;
                    }

                    this.$alert({ type: "error", title: "Login Failed", message: msg });

                    const $this = this;
                    this.$ga.event({
                        eventCategory: "login",
                        eventAction: "login.failed",
                        eventLabel: $this.form.Email,
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.singin-box {
    background: #394c64;
    background: -moz-linear-gradient(top, #394c64 0%, #202d3e 100%);
    background: -webkit-linear-gradient(top, #394c64 0%, #202d3e 100%);
    background: linear-gradient(to bottom, #394c64 0%, #202d3e 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#394c64', endColorstr='#202d3e',GradientType=0 );
    border-radius: 20px;
    width: 540px;
}
.signin-top {
    background: #5ba8ff;
    background: -moz-linear-gradient(top, #5ba8ff 0%, #0f6cb7 100%);
    background: -webkit-linear-gradient(top, #5ba8ff 0%, #0f6cb7 100%);
    background: linear-gradient(to bottom, #5ba8ff 0%, #0f6cb7 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#5ba8ff', endColorstr='#0f6cb7',GradientType=0 );
    height: 100%;
    padding: 20px 10px;
    background-color: #5ba8ff;
    border-radius: 20px;
    margin-bottom: 20px;
}
.signin-right {
    background: transparent;
    height: 100%;
    padding: 30px 30px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}
.flex-align-end {
    justify-content: flex-end;
}

.dx-uppercase input {
    text-transform: uppercase !important;
}
</style>
